import React from 'react';
import { Button } from './ui/button';
import { Dialog, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';

// Preferred field order at the top of the table; everything else follows.
const PRIORITY = ['id', 'title', 'description'];

function orderColumns(row, columns) {
  // Use the provided column order if given, otherwise derive from the record's
  // own keys (e.g. when opened from the comparison dialog where the feed's
  // column list isn't known up front).
  const keys = columns && columns.length ? columns : Object.keys(row || {});
  const seen = new Set();
  const ordered = [];
  for (const k of PRIORITY) if (keys.includes(k) && !seen.has(k)) { ordered.push(k); seen.add(k); }
  for (const k of keys) if (!seen.has(k)) { ordered.push(k); seen.add(k); }
  return ordered;
}

/**
 * Rich record inspector — an image gallery at the top and a wrapping field
 * table (id, title, description, all g: fields). Shared between the feed
 * preview and the comparison "which items mismatch" view.
 */
export default function RecordModal({ row, columns, onClose }) {
  const r = row || {};
  const main = r.image_link;
  const addl = Array.isArray(r.additional_image_link) ? r.additional_image_link : (r.additional_image_link ? [r.additional_image_link] : []);
  const imgs = [main, ...addl].filter(Boolean);
  const cols = orderColumns(r, columns);
  return (
    <Dialog open={!!row} onClose={onClose} className="max-w-5xl">
      {row && (
        <>
          <DialogHeader>
            <DialogTitle className="truncate">{r.title || r.id}</DialogTitle>
            <DialogDescription>
              id {r.id}
              {r.link && <> · <a href={r.link} target="_blank" rel="noreferrer" className="text-sky-600 hover:underline">open product ↗</a></>}
            </DialogDescription>
          </DialogHeader>
          <div className="max-h-[78vh] space-y-3 overflow-y-auto pr-1">
            {imgs.length > 0 && (
              <div className="flex gap-2 overflow-x-auto pb-1">
                {imgs.slice(0, 10).map((u, i) => (
                  <img key={i} src={u} alt="" loading="lazy" className="h-28 w-28 shrink-0 rounded-md border border-border bg-white object-contain" />
                ))}
              </div>
            )}
            <div>
              {cols.map((c) => {
                const v = Array.isArray(r[c]) ? r[c].join('  |  ') : r[c];
                if (v === '' || v == null) return null;
                return (
                  <div key={c} className="flex gap-4 border-b border-border/50 py-1.5 text-[13px]">
                    <code className="w-52 shrink-0 text-muted-foreground">{c}</code>
                    <span className="min-w-0 flex-1 whitespace-pre-line break-words">
                      {c === 'link' || c === 'image_link' ? <a href={v} target="_blank" rel="noreferrer" className="text-sky-600 hover:underline">{String(v)}</a> : String(v)}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
          <DialogFooter><Button variant="outline" onClick={onClose}>Close</Button></DialogFooter>
        </>
      )}
    </Dialog>
  );
}
